import { AUTH_PROFILE, AUTH_TOKEN, BASE_URL, CONSTANTS } from "../constants/mainAPI";
import { METHOD_PUT } from "../constants/common";
import { AuthParams } from "../types/common";
import {
    AuthProfileErrorResponse,
    AuthProfileSuccessResponse,
    AuthTokenErrorResponse,
    AuthTokenSuccessResponse,
} from "../types/api/main";
import { $api } from "../axios";
import axios, { AxiosResponse } from "axios";
import { toFormData } from "../utils/toFormData";

export const doGetRequest = (
    path: string,
    isToken: boolean,
    searchParams?: Record<string, any>,
    callback?: (resp: any) => void,
    errorCallback?: (resp: any) => void,
): Promise<AxiosResponse<any>> => {
    const url = new URL(path, BASE_URL).toString();
    return (isToken ? $api : axios)
        .get<any>(url, { params: searchParams })
        .then(response => response.data)
        .then((data: any) => {
            return callback ? callback(data) : data;
        })
        .catch((err: any) => (errorCallback ? errorCallback(err.response.data) : Promise.reject(err.response.data)));
};

export const doPostRequest = (
    path: string,
    isToken: boolean,
    data: FormData,
    searchParams?: Record<string, any>,
    callback?: (resp: any) => void,
    errorCallback?: (resp: any) => void,
): Promise<AxiosResponse<any>> => {
    const url = new URL(path, BASE_URL).toString();
    return (isToken ? $api : axios)
        .post<any>(url, data, { params: searchParams })
        .then(response => response.data)
        .then((data: any) => {
            return callback ? callback(data) : data;
        })
        .catch((err: any) => (errorCallback ? errorCallback(err.response.data) : Promise.reject(err.response.data)));
};

export const doPutRequest = (
    path: string,
    isToken: boolean,
    data: FormData,
    searchParams?: Record<string, any>,
    callback?: (resp: any) => void,
    errorCallback?: (resp: any) => void,
): Promise<AxiosResponse<any>> => {
    data.append("_method", METHOD_PUT);
    const url = new URL(path, BASE_URL).toString();
    return (isToken ? $api : axios)
        .post<any>(url, data, { params: searchParams })
        .then(response => response.data)
        .then((data: any) => {
            return callback ? callback(data) : data;
        })
        .catch((err: any) => (errorCallback ? errorCallback(err.response.data) : Promise.reject(err.response.data)));
};

export const doDeleteRequest = (
    path: string,
    isToken: boolean,
    searchParams?: Record<string, any>,
    callback?: (resp: any) => void,
    errorCallback?: (resp: any) => void,
): Promise<AxiosResponse<any>> => {
    const url = new URL(path, BASE_URL).toString();
    return (isToken ? $api : axios)
        .delete<any>(url, { params: searchParams })
        .then((data: any) => {
            return callback ? callback(data) : data;
        })
        .catch((err: any) => (errorCallback ? errorCallback(err.response.data) : Promise.reject(err.response.data)));
};

export const authToken = (
    data: AuthParams,
    callback?: (resp: AuthTokenSuccessResponse) => any,
    errorCallback?: (resp: AuthTokenErrorResponse) => any,
) => {
    const formData = toFormData(data);
    return doPostRequest(AUTH_TOKEN, false, formData, {}, callback, errorCallback);
};

export const authProfile = (
    callback?: (resp: AuthProfileSuccessResponse) => any,
    errorCallback?: (resp: AuthProfileErrorResponse) => void,
) => {
    return doGetRequest(AUTH_PROFILE, true, {}, callback, errorCallback);
};

export const getConstants = (callback?: (resp: any) => any, errorCallback?: (resp: any) => void) => {
    return doGetRequest(CONSTANTS, false, {}, callback, errorCallback);
};
